const FIRST_TOUCH_KEY = 'tendera:attribution:first-touch';
const LATEST_TOUCH_KEY = 'tendera:attribution:latest-touch';

const TRACKING_PARAM_KEYS = [
    'utm_id',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_creative_format',
    'utm_marketing_tactic',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'msclkid',
    'li_fat_id',
    'ttclid',
    'twclid',
    'intent',
    'plan',
    'target_plan',
    'cta_id',
    'cta_location',
    'cta_label',
    'destination_url',
    'landing_page',
    'source_page',
    'source_path',
    'source_url',
    'source_referrer',
    'page_referrer',
    'page_title',
    'page_type',
    'campaign_id',
    'campaign_name',
    'adgroup_id',
    'adgroup_name',
    'ad_id',
    'ad_name',
    'creative_id',
    'creative_name',
    'placement',
    'keyword',
    'matchtype',
    'network',
    'lang'
];

const readJson = (key) => {
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const writeJson = (key, value) => {
    if (typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // Attribution capture is best-effort and must not break app usage.
    }
};

const getTrackingParams = (search) => {
    const params = new URLSearchParams(search || '');
    return TRACKING_PARAM_KEYS.reduce((acc, key) => {
        const value = params.get(key);
        if (value) acc[key] = value;
        return acc;
    }, {});
};

const cleanUrlForAttribution = (url) => {
    if (!url) return undefined;
    try {
        const parsed = new URL(url, window.location.origin);
        ['_hstc', '_hssc', '_hsfp', '_hsenc', '_hsmi'].forEach((key) => {
            parsed.searchParams.delete(key);
        });
        return parsed.href;
    } catch {
        return url;
    }
};

const getExternalReferrer = () => {
    if (typeof window === 'undefined') return undefined;

    const referrer = window.document?.referrer;
    if (!referrer) return undefined;

    try {
        const parsedReferrer = new URL(referrer);
        if (parsedReferrer.hostname === window.location.hostname) return undefined;
        return cleanUrlForAttribution(parsedReferrer.href);
    } catch {
        return referrer;
    }
};

export const captureAttributionFromUrl = (locationLike = null) => {
    if (typeof window === 'undefined') return null;

    const location = locationLike || window.location;
    const trackingParams = getTrackingParams(location.search);
    const externalReferrer = getExternalReferrer();
    const storedAttribution = getStoredAttribution();

    if (Object.keys(trackingParams).length === 0 && !externalReferrer) {
        return storedAttribution;
    }

    if (Object.keys(trackingParams).length === 0 && externalReferrer) {
        const latestTouch = storedAttribution.latest_touch;
        if (latestTouch?.source_referrer === externalReferrer || latestTouch?.source_url === externalReferrer) {
            return storedAttribution;
        }
    }

    const captured = {
        ...trackingParams,
        captured_at: new Date().toISOString(),
        app_entry_path: location.pathname || window.location.pathname,
        app_entry_url: cleanUrlForAttribution(location.href || window.location.href),
        landing_path: location.pathname || window.location.pathname,
        page_referrer: trackingParams.page_referrer || externalReferrer,
        source_referrer: trackingParams.source_referrer || externalReferrer,
        source_url: trackingParams.source_url || externalReferrer
    };

    if (!readJson(FIRST_TOUCH_KEY)) {
        writeJson(FIRST_TOUCH_KEY, captured);
    }
    writeJson(LATEST_TOUCH_KEY, captured);

    return getStoredAttribution();
};

export const getStoredAttribution = () => ({
    first_touch: readJson(FIRST_TOUCH_KEY),
    latest_touch: readJson(LATEST_TOUCH_KEY)
});
